import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getVendorOptions = async () => {
  const { data } = await axios.get(`${api_base_url}/Vendor/VendorOptions`);

  return data;
};
export const getVendor = async () => {
  const { data } = await axios.get(`${api_base_url}/Vendor/Vendor`);
  return data;
};
export const getVendorList = async (query, _, vendorFilter) => {
  try {
    let params;
    if (vendorFilter !== undefined) {
      params = Object.keys(vendorFilter).reduce((acc, key) => {
        if (vendorFilter[key]?.length > 0 || vendorFilter[key] > 0) {
          acc[key] = vendorFilter[key];
        }
        return acc;
      }, {});
    }

    const queryStrings = new URLSearchParams(params).toString();
    const pageSize = query.pageSize ?? 10;
    const pageNumber = query.page !== undefined ? query.page + 1 : 1;

    const url = queryStrings
      ? `${api_base_url}/Vendor/VendorList?PageNumber=${pageNumber}&PageSize=${pageSize}&search=${query.search}&${queryStrings}`
      : `${api_base_url}/Vendor/VendorList?PageNumber=${pageNumber}&PageSize=${pageSize}&search=${query.search}`;

    const response = await axios.get(url);

    const headers = response.headers || {};
    const pageHeaders = JSON.parse(headers["x-pagination"] || "{}");
    return {
      ...query,
      data: response.data || [],
      page: pageHeaders.CurrentPage ? pageHeaders.CurrentPage - 1 : 0,
      pageSize: pageHeaders.PageSize ?? 0,
      totalCount: pageHeaders.TotalCount || 0,
    };
  } catch (error) {
    return {
      ...query,
      data: [],
      page: 0,
      pageSize: 0,
      totalCount: 0,
    };
  }
};
export const getVendorCount = async () => {
  const { data } = await axios.get(`${api_base_url}/Vendor/GetCount`);
  return data;
};

export const getVendorType = async () => {
  const { data } = await axios.get(`${api_base_url}/Vendor/VendorType`);
  return data;
};

export const getVendorOfficesById = async (vendorId) => {
  return await axios
    .get(`${api_base_url}/Vendor/VendorOffices/${vendorId}`)
    .then((res) => res.data);
};
export const addVendor = async (newVendor) => {
  const formData = new FormData();
  for (const properties in newVendor) {
    // if (
    //   properties === "pciaocAttachment" ||
    //   properties === "soc2ReportAttachment" ||
    //   properties === "securityQuestionnaireAttachment" ||
    //   properties === "miscellaneousAttachment"
    // ) {
    //   //For PCI AOC
    //   newVendor.pciaocAttachment &&
    //     newVendor.pciaocAttachment.map((x) =>
    //       formData.append("pciaocAttachment", x)
    //     );
    //   newVendor.pciaocAttachment &&
    //     formData.append("pciaocAttachment", newVendor.pciaocAttachment);
    //   //For Soc2 Report
    //   newVendor.soc2ReportAttachment &&
    //     newVendor.soc2ReportAttachment.map((x) =>
    //       formData.append("soc2ReportAttachment", x)
    //     );
    //   newVendor.soc2ReportAttachment &&
    //     formData.append("soc2ReportAttachment", newVendor.soc2ReportAttachment);
    //   //For Security Questionnaire
    //   newVendor.securityQuestionnaireAttachment &&
    //     newVendor.securityQuestionnaireAttachment.map((x) =>
    //       formData.append("securityQuestionnaireAttachment", x)
    //     );
    //   newVendor.securityQuestionnaireAttachment &&
    //     formData.append(
    //       "securityQuestionnaireAttachment",
    //       newVendor.securityQuestionnaireAttachment
    //     );
    //   //For Miscellaneous
    //   newVendor.miscellaneousAttachment &&
    //     newVendor.miscellaneousAttachment.map((x) =>
    //       formData.append("miscellaneousAttachment", x)
    //     );
    //   newVendor.miscellaneousAttachment &&
    //     formData.append(
    //       "miscellaneousAttachment",
    //       newVendor.miscellaneousAttachment
    //     );
    // } else
    if (newVendor[properties] !== null && newVendor[properties] !== undefined) {
      formData.append(`${properties}`, newVendor[properties]);
    }
  }
  return await axios.post(`${api_base_url}/Vendor`, formData);
};
export const updateVendor = async (updatedVendor) => {
  const formData = new FormData();
  for (const properties in updatedVendor) {
    // if (
    //   properties === "pciaocAttachment" ||
    //   properties === "soc2ReportAttachment" ||
    //   properties === "securityQuestionnaireAttachment" ||
    //   properties === "miscellaneousAttachment"
    // ) {
    //   //For PCI AOC
    //   updatedVendor.pciaocAttachment &&
    //     updatedVendor.pciaocAttachment.map((x) =>
    //       formData.append("pciaocAttachment", x)
    //     );
    //   updatedVendor.pciaocAttachment &&
    //     formData.append("pciaocAttachment", updatedVendor.pciaocAttachment);
    //   //For Soc2 Report
    //   updatedVendor.soc2ReportAttachment &&
    //     updatedVendor.soc2ReportAttachment.map((x) =>
    //       formData.append("soc2ReportAttachment", x)
    //     );
    //   updatedVendor.soc2ReportAttachment &&
    //     formData.append(
    //       "soc2ReportAttachment",
    //       updatedVendor.soc2ReportAttachment
    //     );
    //   //For Security Questionnaire
    //   updatedVendor.securityQuestionnaireAttachment &&
    //     updatedVendor.securityQuestionnaireAttachment.map((x) =>
    //       formData.append("securityQuestionnaireAttachment", x)
    //     );
    //   updatedVendor.securityQuestionnaireAttachment &&
    //     formData.append(
    //       "securityQuestionnaireAttachment",
    //       updatedVendor.securityQuestionnaireAttachment
    //     );
    //   //For Miscellaneous
    //   updatedVendor.miscellaneousAttachment &&
    //     updatedVendor.miscellaneousAttachment.map((x) =>
    //       formData.append("miscellaneousAttachment", x)
    //     );
    //   updatedVendor.miscellaneousAttachment &&
    //     formData.append(
    //       "miscellaneousAttachment",
    //       updatedVendor.miscellaneousAttachment
    //     );
    // } else
    if (
      updatedVendor[properties] !== null &&
      updatedVendor[properties] !== undefined
    ) {
      let value = updatedVendor[properties];

      if (properties === "isInActive") {
        value = Boolean(updatedVendor[properties]);
        formData.append(`${properties}`, value);
      } else {
        formData.append(`${properties}`, updatedVendor[properties]);
      }
    }
  }

  return await axios.put(
    `${api_base_url}/Vendor/${updatedVendor.id}`,
    formData
  );
};
export const deleteVendor = async (ids) => {
  const data = await axios.delete(`${api_base_url}/Vendor/`, {
    data: ids,
  });
  return data;
};

// Get Inactive Vendor
export const getInactiveVendorCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Vendor/GetInactiveVendorCount`
  );
  return data;
};

// Get Inactive Total Count
export const getInactiveTotalCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Vendor/GetInactiveTotalCount`
  );
  return data;
};

// Get Active Total Count
export const getActiveTotalCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Vendor/GetActiveTotalCount`
  );
  return data;
};
// Get Vendor Details For Download
export const getVendorsForDownload = async (ids) => {
  return await axios
    .post(`${api_base_url}/Vendor/GetVendorsForDownload`, ids)
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};

//Get Vendor Count
export const getAllVendorsCount = async () => {
  return axios.get(`${api_base_url}/GetVendorCounts`).then((res) => {
    return res.data;
  });
};

export const getSearchForDownload = async (search) => {
  const { data } = await axios.get(
    `${api_base_url}/Vendor/SearchDownload?search=${search}`
  );
  return data;
};
//Get Vendor Recurrency
export const getVendorRecurrency = async () => {
  return axios.get(`${api_base_url}/Vendor/VendorRecurrency`).then((res) => {
    return res.data;
  });
};

// Check if duplicate Vendor Code
export const checkVendorDuplicate = async (vandorData) => {
  return await axios
    .post(`${api_base_url}/Vendor/CheckVendorDuplicate`, vandorData)
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};

export const getVendorById = async (vendorId) => {
  return await axios
    .get(`${api_base_url}/Vendor/GetVendorById/${vendorId}`, vendorId)
    .then((res) => {
      return res.data;
    });
};

export const getVendorWithVendorStorage = async () => {
  const { data } = await axios.get(`${api_base_url}/Vendor/VendorStorageType`);
  return data;
};

export const getVendorLeasdEquipmentById = async (vendorId) => {
  return await axios
    .get(`${api_base_url}/Vendor/VendorLeasedEquipment/${vendorId}`)
    .then((res) => res.data);
};

export const getPdf = async (file) => {
  const data = await axios.get(
    `${api_base_url}/Vendor/GetPdf?fileName=${file}`,
    {
      responseType: "arraybuffer",
    }
  );
  return data;
};

export const runVendorQuestionnaire = async (data) => {
  return await axios
    .put(`${api_base_url}/Job/QuestionnaireService`, data)
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};

export const getQuestionnaireType = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Vendor/VendorSecurityQuestionnaireType`
  );
  return data;
};

export const getVendorSecurityQuestions = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Vendor/VendorSecurityQuestions`
  );
  return data;
};

export const getVendorSecurityQuestionnaireByTypeId = async (vendorId) => {
  const response = axios.get(
    `${api_base_url}/Vendor/VendorSecurityQuestionnaires?vendorId=${vendorId}`
  );
  return response;
};

export const getVendorSecurityHistory = async (vendorId) => {
  return await axios
    .get(`${api_base_url}/Vendor/VendorSecurityHistory/${vendorId}`)
    .then((res) => {
      return res.data;
    });
};
